import React from 'react';
import '../styling/TermsPage.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> 2025-03-28</p>
      
      <h2>1. Introduction</h2>
      <p>
        Welcome to Kyro Game Studios’ website (the “Site”), owned and operated by Kyro Studios (“we,” “us,” or “our”). This Site provides information about our current game(s) and links for downloading our software, as well as details on future projects. By accessing or using this Site, you agree to be bound by these Terms of Service (“Terms”). If you do not agree to these Terms, please do not use our Site.
      </p>
      
      <h2>2. Acceptance of Terms</h2>
      <p>
        By using or accessing any portion of this Site, including any downloadable content, you acknowledge that you have read, understood, and agree to be bound by these Terms. Continued use of the Site constitutes acceptance of any modifications to these Terms.
      </p>
      
      <h2>3. Use of the Site</h2>
      <p><strong>Permitted Use:</strong></p>
      <ul>
        <li>
          We grant you a limited, non-exclusive, revocable license to access and use the Site solely for your personal, non-commercial information and download purposes.
        </li>
      </ul>
      <p><strong>Prohibited Conduct:</strong></p>
      <ul>
        <li>
          You agree not to misuse the Site by engaging in any unlawful activities or actions that could disrupt the functionality or integrity of the Site. This includes, but is not limited to, unauthorized access, interference with server performance, or the distribution of malicious code.
        </li>
      </ul>
      
      <h2>4. Intellectual Property</h2>
      <p>
        All content on this Site—including text, images, graphics, logos, and downloadable game software—is the property of Kyro Studios or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not modify, reproduce, distribute, or create derivative works without our express written consent.
      </p>
      
      <h2>5. Downloads and Software</h2>
      <p><strong>Download Links:</strong></p>
      <ul>
        <li>
          Our Site may provide links to download our current game and future titles. We strive to ensure that these downloads are free from viruses or other harmful components, but we do not guarantee the security or functionality of the downloaded software.
        </li>
      </ul>
      <p><strong>License for Downloads:</strong></p>
      <ul>
        <li>
          When you download any game or software from our Site, you are granted a non-exclusive, non-transferable license to use the software for personal use only. Commercial use or distribution is strictly prohibited unless otherwise authorized by Kyro Studios.
        </li>
      </ul>
      
      <h2>6. Third-Party Links</h2>
      <p>
        Our Site may contain links to third-party websites or services that are not owned or controlled by Kyro Studios. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites. Your use of such websites is at your own risk.
      </p>
      
      <h2>7. Disclaimers and Limitation of Liability</h2>
      <p><strong>Disclaimer of Warranties:</strong></p>
      <ul>
        <li>
          The Site and all downloadable content are provided on an "as-is" and "as available" basis without warranties of any kind, either express or implied. Kyro Studios disclaims any warranties regarding the accuracy, reliability, or suitability of the content on this Site or the downloaded software.
        </li>
      </ul>
      <p><strong>Limitation of Liability:</strong></p>
      <ul>
        <li>
          To the fullest extent permitted by applicable law, Kyro Studios shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of your access to, or use of, the Site or any downloadable content.
        </li>
      </ul>
      
      <h2>8. Modifications to Terms</h2>
      <p>
        We reserve the right to modify or update these Terms at any time. Any changes will be posted on this page with an updated effective date. Your continued use of the Site after such changes constitutes your acceptance of the revised Terms.
      </p>
      
      <h2>9. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of Ontario, Canada. Any disputes arising under or in connection with these Terms or your use of the Site shall be resolved exclusively in the appropriate courts located within Ontario, Canada.
      </p>
      
      <h2>10. Contact Information</h2>
      <p>
        If you have any questions about these Terms or the Site, please contact us at:
      </p>
      <p>
        <strong>Kyro Studios</strong><br />
        <a href="mailto:your-email@example.com">support@kyrogamestudios.com</a>
      </p>
    </div>
  );
};

export default TermsOfService;
